module.exports = __webpack_public_path__ + "img/yahya-goga.d34a8974.jpg";